import { Injectable } from '@angular/core';
import { MessageToastService } from '@fundamental-ngx/core';
import { MessageToastConfig } from '@fundamental-ngx/core/message-toast';
import { AlertSettings } from '@luigi-project/client';
import { firstValueFrom } from 'rxjs';

const TOAST_ALERT_TYPE = 'message-toast';
export interface DxpAlertSettings extends Omit<AlertSettings, 'type'> {
  type: AlertSettings['type'] | typeof TOAST_ALERT_TYPE;
}

@Injectable({
  providedIn: 'root',
})
export class AlertHandlerService {
  constructor(private messageToastService: MessageToastService) {}

  public handler = (settings: DxpAlertSettings) => {
    switch (settings.type) {
      case TOAST_ALERT_TYPE:
        return this.showMessageToast(settings);
      default:
        return false;
    }
  };

  private async showMessageToast(settings: DxpAlertSettings): Promise<void> {
    const config: MessageToastConfig = {
      duration: settings.closeAfter,
    };

    const mtr = this.messageToastService.open(settings.text ?? '', config);

    return firstValueFrom(mtr.afterTimeout);
  }
}
